import React from "react";
import { motion } from "framer-motion";

/**
 * Renders a heading whose lines animate in via mask reveal.
 * Pass `lines` as an array of strings. Each string becomes an animated line.
 */
export default function MaskedReveal({
  lines = [],
  className = "",
  delay = 0,
  as = "h1",
  accentIndex = null,
}) {
  const Tag = motion[as];

  return (
    <Tag className={className}>
      {lines.map((text, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{
              duration: 1.05,
              ease: [0.22, 1, 0.36, 1],
              delay: delay + i * 0.14,
            }}
            className={`inline-block will-change-transform ${
              accentIndex === i ? "text-brand-accent" : ""
            }`}
          >
            {text}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
